(() => {
  'use strict';
  if (window.dpAdsTrackingInitialized) return;
  window.dpAdsTrackingInitialized = true;
  const key = 'dp.ads.pending.v1';
  const base = 'AW-16621621521';
  const callDestination = base + '/73BACLHu4pwdEJGi5_U9';
  const formDestination = base + '/yxE9CLTu4pwdEJGi5_U9';
  const clickDestination = base + '/8EVFCOiK2P0aEJGi5_U9';
  let configured = false;
  let callsRequested = false;
  let attempts = 0;
  let privacyRequested = false;
  let restoredFromHistory = false;
  const replacements = [];
  function status(value) {
    document.documentElement.dataset.dpTrackingStatus = value;
  }
  function allowed() {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!privacy && privacy.marketingAllowed() === true &&
        privacy.analyticsProcessingAllowed() === true && privacy.saleOfDataAllowed() === true;
    } catch (_) { return false; }
  }
  function forget() {
    try { window.sessionStorage.removeItem(key); } catch (_) {}
  }
  function ready() {
    return allowed() && typeof window.gtag === 'function' &&
      !!document.querySelector('script[src*="googletagmanager.com/gtag/js"]');
  }
  function restorePhones() {
    for (const item of replacements.splice(0)) {
      if (item.attribute) item.node.setAttribute(item.attribute, item.original);
      else item.node.nodeValue = item.original;
    }
  }
  function replacePhones(formatted, mobile) {
    if (!allowed() || typeof formatted !== 'string' || typeof mobile !== 'string' || !/^\+?\d{10,15}$/.test(mobile)) return;
    restorePhones();
    const numberPattern = /\(561\)\s*312-5442|561[. -]312[. -]5442/g;
    for (const link of document.querySelectorAll('a[href^="tel:"]')) {
      const digits = link.getAttribute('href').replace(/\D/g, '');
      if (digits !== '15613125442' && digits !== '5613125442') continue;
      replacements.push({ node: link, attribute: 'href', original: link.getAttribute('href') });
      link.setAttribute('href', 'tel:' + mobile);
      for (const attribute of ['aria-label', 'title']) {
        const original = link.getAttribute(attribute);
        if (original && /561/.test(original)) {
          replacements.push({ node: link, attribute, original });
          link.setAttribute(attribute, original.replace(numberPattern, formatted));
        }
      }
    }
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.parentElement.closest('script,style,textarea,noscript,template')) continue;
      const original = node.nodeValue;
      const changed = original.replace(numberPattern, formatted);
      if (changed !== original) {
        replacements.push({ node, original });
        node.nodeValue = changed;
      }
    }
  }
  function processSuccess() {
    if (!ready() || restoredFromHistory) return;
    const navigation = window.performance && window.performance.getEntriesByType('navigation')[0];
    if (!navigation || navigation.type !== 'navigate') return;
    const markers = Array.from(document.querySelectorAll('[data-dp-confirmed-form]'));
    if (!markers.length) {
      if (document.querySelector('[data-dept-errors], [data-dp-lead-errors]')) forget();
      return;
    }
    try {
      const pending = JSON.parse(window.sessionStorage.getItem(key) || 'null');
      if (!pending || !/^[a-f0-9-]{36}$/.test(pending.id) || pending.path !== window.location.pathname ||
          Date.now() - pending.time < 0 || Date.now() - pending.time > 30 * 60 * 1000 ||
          !markers.some(marker => marker.getAttribute('data-dp-confirmed-form') === pending.form)) return;
      window.sessionStorage.removeItem(key);
      if (window.sessionStorage.getItem(key) !== null || !ready()) return;
      window.gtag('event', 'conversion', { send_to: formDestination, transaction_id: pending.id });
      status('form-event-queued');
    } catch (_) {}
  }
  function sync() {
    if (!allowed()) {
      if (window.Shopify && window.Shopify.customerPrivacy) forget();
      restorePhones();
      callsRequested = false;
      status('consent-unavailable');
      return;
    }
    if (!ready()) { status('waiting-for-existing-google-tag'); return; }
    if (!configured) {
      window.gtag('config', base, { send_page_view: false, allow_enhanced_conversions: false, groups: 'dp_ads' });
      configured = true;
    }
    if (!callsRequested) {
      callsRequested = true;
      window.gtag('config', callDestination, {
        phone_conversion_number: '(561) 312-5442',
        phone_conversion_callback: replacePhones,
        phone_conversion_options: { cache: false },
        send_page_view: false,
        groups: 'dp_ads'
      });
    }
    status('ready');
    processSuccess();
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.querySelector('dp-department-form, [data-dp-lead-form]')) return;
    forget();
    if (!event.isTrusted || !allowed() || !form.checkValidity()) return;
    queueMicrotask(() => {
      if (!allowed() || (event.defaultPrevented && !form.hasAttribute('data-hcaptcha-bound'))) return;
      try {
        window.sessionStorage.setItem(key, JSON.stringify({
          id: window.crypto.randomUUID(), form: form.id, path: window.location.pathname, time: Date.now()
        }));
      } catch (_) {}
    });
  });
  document.addEventListener('click', event => {
    const link = event.target instanceof Element && event.target.closest('a[href^="tel:"]');
    if (!link || !event.isTrusted || !ready()) return;
    window.gtag('event', 'conversion', {
      send_to: clickDestination, value: 1.0, currency: 'USD', transport_type: 'beacon'
    });
  });
  document.addEventListener('visitorConsentCollected', sync);
  window.addEventListener('pageshow', event => {
    restoredFromHistory = event.persisted === true;
    sync();
  });
  function initialize() {
    const shopify = window.Shopify;
    if (shopify && shopify.customerPrivacy) sync();
    else if (shopify && typeof shopify.loadFeatures === 'function' && !privacyRequested) {
      privacyRequested = true;
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
        if (!error) sync();
        else status('privacy-api-unavailable');
      });
    }
    if ((!configured || !shopify || !shopify.customerPrivacy) && ++attempts < 60) window.setTimeout(initialize, 500);
  }
  initialize();
})();
